import { optionsFunction } from "./_config";
import axios from "axios";

export const getConfig = () => axios.get(`api/config`, optionsFunction());

export const getConfigWithLocale = (localeQuery) =>
  axios.get(`api/config?locale=${localeQuery}`, optionsFunction());

export const flushCache = () => {
  axios.post("api/tests/reset?cache=1", {}, optionsFunction());
};
export const sendReferral = ({ parameter, os, resolution }) => {
  return axios.post(
    "api/referral",
    {
      parameter,
      os,
      resolution,
    },
    optionsFunction()
  );
};
